import type { MediaItem } from "../types/mediaLibraryTypes";

export function mediaTransformer(dto: MediaItem[]): MediaItem[] {
  if (!Array.isArray(dto)) {
    return [];
  }

  return dto.map(
    (item: any): MediaItem => ({
      id: String(item.id),
      groupId: String(item.groupId),
      downloadUrl: item.downloadUrl,
      previewUrl: item.previewUrl,
      mediaType: item.mediaType,
      isFavourite: Boolean(item.isFavourite),
      title: item.title || "",
      language: item.language || "",
      documentType: item.documentType || "",
    }),
  );
}
